import {Space} from "antd";
import {
  CreateServiceOfferingFormGroups,
  EditServiceOfferingFormGroups,
} from "../accordion/data";
import {applyOfferingFormFeatureFlags} from "../accordion/apply-feature-flags-to-form-groups";
import {OfferingFormAccordionItem} from "../accordion/accordion-item";
import {ServiceOfferingFormProps} from "./types";
import {ServiceSettingsFormFields} from "./settings";
import {RedirectAfterPurchaseFormFields} from "../session-bundle/session/redirect-after-purchase";

export function CreateServiceOfferingForm({
  isGeneralInformationError,
  isPricingError,
  isSettingsError,
  isDeliveryTimeFrameError,
}: ServiceOfferingFormProps) {
  return (
    <Space direction="vertical" size={16} style={{display: "flex"}}>
      {applyOfferingFormFeatureFlags(CreateServiceOfferingFormGroups).map((fg, index) => {
        if (fg.title === "General information") {
          return (
            <OfferingFormAccordionItem
              key={fg.title}
              index={index}
              title={fg.title}
              isError={isGeneralInformationError}
            >
              {fg.children}
            </OfferingFormAccordionItem>
          );
        } else if (fg.title === "Delivery Time frame") {
          return (
            <OfferingFormAccordionItem
              key={fg.title}
              index={index}
              title={fg.title}
              isError={isDeliveryTimeFrameError}
            >
              {fg.children}
            </OfferingFormAccordionItem>
          );
        } else if (fg.title === "Pricing") {
          return (
            <OfferingFormAccordionItem
              key={fg.title}
              index={index}
              title={fg.title}
              isError={isPricingError}
            >
              {fg.children}
            </OfferingFormAccordionItem>
          );
        } else if (fg.title === "Email automation") {
          return (
            <OfferingFormAccordionItem key={fg.title} index={index} title={fg.title}>
              {fg.children}
            </OfferingFormAccordionItem>
          );
        } else if (fg.title === "Settings") {
          return (
            <OfferingFormAccordionItem
              key={fg.title}
              index={index}
              title={fg.title}
              isError={isSettingsError}
            >
              <ServiceSettingsFormFields showUrlRedirect={false} />
            </OfferingFormAccordionItem>
          );
        } else if (fg.title === "Redirect after purchase") {
          return (
            <OfferingFormAccordionItem
              key={fg.title}
              index={index}
              title={fg.title}
              isError={isSettingsError}
            >
              <RedirectAfterPurchaseFormFields />
            </OfferingFormAccordionItem>
          );
        } else {
          return null;
        }
      })}
    </Space>
  );
}
export function EditStoreServiceOfferingForm({
  isGeneralInformationError,
  isPricingError,
  isSettingsError,
  isCoverImagesError,
  isDeliveryTimeFrameError,
  isPortfolioImagesError,
}: ServiceOfferingFormProps) {
  return (
    <Space direction="vertical" size={16} style={{display: "flex"}}>
      {applyOfferingFormFeatureFlags(EditServiceOfferingFormGroups).map((fg, index) => {
        if (fg.title === "General information") {
          return (
            <OfferingFormAccordionItem
              key={fg.title}
              index={index}
              title={fg.title}
              isError={isGeneralInformationError}
            >
              {fg.children}
            </OfferingFormAccordionItem>
          );
        } else if (fg.title === "Cover images") {
          return (
            <OfferingFormAccordionItem
              key={fg.title}
              index={index}
              title={fg.title}
              isError={isCoverImagesError}
            >
              {fg.children}
            </OfferingFormAccordionItem>
          );
        } else if (fg.title === "Portfolio images") {
          return (
            <OfferingFormAccordionItem
              key={fg.title}
              index={index}
              title={fg.title}
              isError={isPortfolioImagesError}
            >
              {fg.children}
            </OfferingFormAccordionItem>
          );
        } else if (fg.title === "Delivery Time frame") {
          return (
            <OfferingFormAccordionItem
              key={fg.title}
              index={index}
              title={fg.title}
              isError={isDeliveryTimeFrameError}
            >
              {fg.children}
            </OfferingFormAccordionItem>
          );
        } else if (fg.title === "Pricing") {
          return (
            <OfferingFormAccordionItem
              key={fg.title}
              index={index}
              title={fg.title}
              isError={isPricingError}
            >
              {fg.children}
            </OfferingFormAccordionItem>
          );
        } else if (fg.title === "Email automation") {
          return (
            <OfferingFormAccordionItem key={fg.title} index={index} title={fg.title}>
              {fg.children}
            </OfferingFormAccordionItem>
          );
        } else if (fg.title === "Settings") {
          return (
            <OfferingFormAccordionItem
              key={fg.title}
              index={index}
              title={fg.title}
              isError={isSettingsError}
            >
              <ServiceSettingsFormFields showUrlRedirect={false} />
            </OfferingFormAccordionItem>
          );
        } else if (fg.title === "Redirect after purchase") {
          return (
            <OfferingFormAccordionItem
              key={fg.title}
              index={index}
              title={fg.title}
              isError={isSettingsError}
            >
              <RedirectAfterPurchaseFormFields />
            </OfferingFormAccordionItem>
          );
        } else {
          return null;
        }
      })}
    </Space>
  );
}
